// extracted by mini-css-extract-plugin
export default {"scratchpadPage":"LRScratchpad_scratchpadPage__jtwWv","timelineFormSec":"LRScratchpad_timelineFormSec__nn8dn","evidenceFormH4":"LRScratchpad_evidenceFormH4__hSWZk"};